import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { FCM_STARTER_DASHBOARD_CONTACT_DM } from '@change-corgi/fcm/configs';

export async function getStarterContactDmConfig(utilityContext: UtilityContext) {
	const { starterContactDmConfig } = await utilityContext.fcm.get({
		starterContactDmConfig: FCM_STARTER_DASHBOARD_CONTACT_DM,
	});

	return {
		emailEnabled: !!starterContactDmConfig?.emailEnabled,
		emailSubjectLine: starterContactDmConfig?.emailSubjectLine || '',
		emailBody: starterContactDmConfig?.emailBody || [],
	};
}
